module.exports = __webpack_public_path__ + "img/17.f7904623.png";